import createSagaMiddleware from 'redux-saga'
import { createLogger } from 'redux-logger'
import rootSaga from './root-saga'
import { persistenceMiddleware } from './persistence-middleware'
import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './auth/auth-reducer'
import { meterTableReducer } from './meter-table/meter-table-reducer'
import { dataReducer } from './data/data-reducer'
import { adminReducer } from './admin/admin-companies-reducer'
import { adminDeviceProvisionsReducer } from './admin/admin-device-provisions-reducer'
import { meterReducer } from './meters/meter-reducer'
import { messagesReducer } from './messages/messages-reducer'
import { settingsReducer } from './settings/setting-reducer'
import { noticesReducer } from './notices/notices-reducer'

export const allReducers = {
  admin: adminReducer,
  adminDeviceProvisions: adminDeviceProvisionsReducer,
  auth: authReducer,
  data: dataReducer,
  messages: messagesReducer,
  meter: meterReducer,
  meterTable: meterTableReducer,
  notices: noticesReducer,
  settings: settingsReducer
}

const loggerMiddleware = createLogger()
const sagaMiddleware = createSagaMiddleware()

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const configureStoreWithMiddleware = () => {
  const customMiddleware = [
    persistenceMiddleware,
    sagaMiddleware,
    loggerMiddleware
  ]

  const store = configureStore({
    reducer: allReducers,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware().concat(customMiddleware)
    },
    devTools: process.env.NODE_ENV !== 'production'
  })

  sagaMiddleware.run(rootSaga)

  return store
}

const store = configureStoreWithMiddleware()

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function getStore() {
  return store
}

export type AppStore = typeof store
export type RootState = ReturnType<AppStore['getState']>
export type GetStateFunc = () => RootState

export type AppDispatch = AppStore['dispatch']

/**
 * Type of all application reducers.
 */
export type AppReducers = typeof allReducers
